import(/* webpackMode: "eager" */ "/vercel/path0/components/BlogContent.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/footer.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/navbar.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/PopularArticles.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/scrollToTopButton.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
